export default __webpack_public_path__ + "static/media/F0005.43369334.png";